import React from 'react';

export const SettingsIcon = ({ width = 32, height = 32, color = "#D9D9D9", className }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={className}
                d="M21.3333 19.9999C26.6786 19.9133 30.6666 15.9559 30.6666 10.6666C30.6666 6.65059 29.3373 7.97992 27.9999 9.33325C26.6786 10.6399 23.9999 13.3333 23.9999 13.3333L18.6666 7.99992C18.6666 7.99992 21.3599 5.32125 22.6666 3.99992C24.0199 2.66259 24.0199 1.33325 21.3333 1.33325C16.0439 1.33325 12.0706 5.32125 11.9999 10.6666C12.0559 11.9679 11.9999 14.6666 11.9999 14.6666C9.4866 17.1959 6.21327 20.4706 3.99994 22.6666C0.0906045 26.5919 5.40794 31.9093 9.33327 27.9999C11.5333 25.7839 14.8173 22.4999 17.3333 19.9999C17.3333 19.9999 20.0319 19.9439 21.3333 19.9999Z"
                stroke={color}
                strokeWidth="2.66667"
            />
        </svg>
    );
};